import { useGameStore } from '../../store';

export default function ReviveModal() {
  const show             = useGameStore((s) => s.showReviveModal);
  const completeReviveAd = useGameStore((s) => s.completeReviveAd);
  const setShow          = useGameStore((s) => s.setShow);

  if (!show) return null;

  return (
    <div className="modal-backdrop center" style={{ display: 'flex' }}>
      <div className="modal-sheet mid">
        <div className="modal-title">😱 파산 직전이오!</div>
        <div className="modal-body" style={{ textAlign: 'center' }}>
          냥이 바닥났소이다.<br />사채업자가 나타났소.<br />
          <strong style={{ color: 'var(--gold)', fontSize: 18 }}>+3,000만냥</strong>
        </div>
        <button className="modal-btn" onClick={completeReviveAd}>냥 빌려받기</button>
        <button className="modal-btn ghost" onClick={() => setShow('showReviveModal', false)}>
          괜찮소, 그냥 하겠소
        </button>
      </div>
    </div>
  );
}
